<template>
  <div class="modal fade" id="error-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeErrorModal" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-support mr-5"></i>{{'contact_us' | translate}}</h4>
        </div>
        <div class="modal-body text-center">
          <p class="mt-10 lead"><span class="fa fa-support mr-5"></span>{{'support' | translate}}</p>
          <p class="margin"></p>
          <div class="row">
            <div class="col-xs-12">
              {{'support_error_message' | translate}}
            </div>
          </div>
          <br/>
          <div class="row">
            <div class="col-xs-6">
              <span><i class="fa fa-phone"></i> <a href="tel:+4961829282274">+49 6182 928 2274</a></span>
            </div>
            <div class="col-xs-6">
              <span><i class="fa fa-envelope"></i> <a href="mailto:service@schuhe.de">service@schuhe.de</a></span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline btn-app no-margin" data-dismiss="modal"><span class="fa fa-times"></span>{{'cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/SupportModal.vue